export default __webpack_public_path__ + "static/media/GSP4.1fb45bc4.png";